// config/resourceTemplates.js
// Pre-built HTML templates for each resource content type

const TEMPLATES = [
  {
    id: "newsletter-monthly",
    name: "Monthly Newsletter",
    content_type: "newsletter",
    description: "Professional newsletter with header, table of contents, multiple sections, and branded footer.",
    icon: "mail",
    html: `<div style="max-width:700px;margin:0 auto;font-family:Georgia,serif;color:#333;">

<!-- HEADER -->
<div style="background:linear-gradient(135deg,#135879,#0e4562);color:white;padding:40px 30px;text-align:center;border-radius:12px 12px 0 0;">
  <div style="font-size:12px;text-transform:uppercase;letter-spacing:3px;color:#d4af37;margin-bottom:10px;">Monthly Newsletter</div>
  <h1 style="margin:0;font-size:28px;font-weight:bold;color:white;">Al-Tijaarat Al-Raabehah</h1>
  <h2 style="margin:5px 0 0;font-size:18px;font-weight:normal;color:#d4af37;">Chicago</h2>
  <div style="margin-top:15px;font-size:14px;color:rgba(255,255,255,0.8);">[Month Year] Edition</div>
</div>
<div style="height:4px;background:#d4af37;"></div>

<!-- TABLE OF CONTENTS -->
<div style="background:#f8f6f0;padding:25px 30px;border-bottom:1px solid #e0ddd5;">
  <h3 style="margin:0 0 12px;font-size:14px;text-transform:uppercase;letter-spacing:2px;color:#135879;">In This Issue</h3>
  <ul style="margin:0;padding:0;list-style:none;font-size:14px;line-height:2;">
    <li>&#x2022; [Main Article Title]</li>
    <li>&#x2022; [Events Update]</li>
    <li>&#x2022; [Business Spotlight]</li>
    <li>&#x2022; [Announcements]</li>
  </ul>
</div>

<!-- SECTION 1 -->
<div style="padding:30px;">
  <div style="margin-bottom:20px;">
    <div style="width:4px;height:30px;background:#d4af37;display:inline-block;vertical-align:middle;margin-right:15px;"></div>
    <h2 style="display:inline-block;vertical-align:middle;margin:0;font-size:22px;color:#135879;">[Main Article Title]</h2>
  </div>
  <p style="font-size:15px;line-height:1.8;color:#444;">[Write your main article content here. This is the featured story of the newsletter.]</p>
</div>
<div style="height:1px;background:#e0ddd5;margin:0 30px;"></div>

<!-- SECTION 2 -->
<div style="padding:30px;">
  <div style="margin-bottom:20px;">
    <div style="width:4px;height:30px;background:#d4af37;display:inline-block;vertical-align:middle;margin-right:15px;"></div>
    <h2 style="display:inline-block;vertical-align:middle;margin:0;font-size:22px;color:#135879;">[Events Update]</h2>
  </div>
  <div style="background:#f8f6f0;padding:20px;border-radius:8px;margin-bottom:12px;">
    <h4 style="margin:0 0 8px;color:#135879;">[Event Name]</h4>
    <p style="margin:0;font-size:14px;line-height:1.6;color:#555;">[Event description and recap]</p>
  </div>
</div>
<div style="height:1px;background:#e0ddd5;margin:0 30px;"></div>

<!-- SECTION 3 -->
<div style="padding:30px;">
  <div style="margin-bottom:20px;">
    <div style="width:4px;height:30px;background:#d4af37;display:inline-block;vertical-align:middle;margin-right:15px;"></div>
    <h2 style="display:inline-block;vertical-align:middle;margin:0;font-size:22px;color:#135879;">[Business Spotlight]</h2>
  </div>
  <div style="background:#f8f6f0;padding:25px;border-radius:12px;border:1px solid #e0ddd5;">
    <h3 style="margin:0 0 5px;color:#135879;font-size:18px;">[Business Owner Name]</h3>
    <p style="margin:0 0 15px;font-size:14px;color:#d4af37;">[Business Name]</p>
    <p style="font-size:14px;line-height:1.7;color:#555;">[Success story or business description]</p>
  </div>
</div>
<div style="height:1px;background:#e0ddd5;margin:0 30px;"></div>

<!-- ANNOUNCEMENTS -->
<div style="padding:30px;">
  <div style="margin-bottom:20px;">
    <div style="width:4px;height:30px;background:#d4af37;display:inline-block;vertical-align:middle;margin-right:15px;"></div>
    <h2 style="display:inline-block;vertical-align:middle;margin:0;font-size:22px;color:#135879;">Announcements</h2>
  </div>
  <p style="font-size:15px;line-height:1.8;color:#444;">[Your announcements here]</p>
</div>

<!-- QUOTE -->
<div style="background:linear-gradient(135deg,#135879,#0e4562);padding:35px 30px;text-align:center;">
  <p style="font-size:18px;line-height:1.6;color:#d4af37;font-style:italic;margin:0 0 15px;">&#x201c;[Inspirational quote]&#x201d;</p>
  <p style="font-size:14px;color:rgba(255,255,255,0.8);margin:0;">&#x2014; [Attribution]</p>
</div>

<!-- FOOTER -->
<div style="background:#1a1a1a;color:rgba(255,255,255,0.6);padding:25px 30px;text-align:center;border-radius:0 0 12px 12px;font-size:12px;line-height:1.8;">
  <p style="margin:0 0 5px;color:#d4af37;font-size:14px;font-weight:bold;">Al-Tijaarat Al-Raabehah &#x2014; Chicago</p>
  <p style="margin:0;">Empowering Mumineen for Ethical and Sustainable Business Growth</p>
  <p style="margin:10px 0 0;"><a href="mailto:tr@chicagojamaat.org" style="color:#d4af37;text-decoration:none;">tr@chicagojamaat.org</a></p>
</div>

</div>`,
  },
  {
    id: "blog-article",
    name: "Blog Article",
    content_type: "blog",
    description: "Clean article layout with hero section, byline, body content, and callout boxes.",
    icon: "article",
    html: `<div style="max-width:700px;margin:0 auto;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;color:#333;">

<h1 style="font-size:32px;font-weight:bold;color:#135879;margin-bottom:10px;line-height:1.3;">[Article Title]</h1>

<div style="display:flex;align-items:center;gap:15px;margin-bottom:30px;padding-bottom:20px;border-bottom:1px solid #eee;">
  <div>
    <p style="margin:0;font-size:14px;font-weight:600;color:#333;">[Author Name]</p>
    <p style="margin:2px 0 0;font-size:13px;color:#888;">[Date] &bull; [X] min read</p>
  </div>
</div>

<p style="font-size:18px;line-height:1.7;color:#555;margin-bottom:30px;font-style:italic;">[Write a compelling introduction that hooks the reader and summarizes the key point of your article.]</p>

<h2 style="font-size:24px;color:#135879;margin:35px 0 15px;">[First Section Heading]</h2>
<p style="font-size:16px;line-height:1.8;color:#444;">[Your content here. Write in clear, engaging paragraphs.]</p>

<h2 style="font-size:24px;color:#135879;margin:35px 0 15px;">[Second Section Heading]</h2>
<p style="font-size:16px;line-height:1.8;color:#444;">[Continue your article with supporting points and details.]</p>

<!-- Callout Box -->
<div style="background:#f0f7fa;border-left:4px solid #135879;padding:20px 25px;margin:30px 0;border-radius:0 8px 8px 0;">
  <p style="margin:0;font-size:15px;line-height:1.6;color:#135879;font-weight:500;">[Key takeaway or important quote that you want to highlight for readers.]</p>
</div>

<h2 style="font-size:24px;color:#135879;margin:35px 0 15px;">[Third Section Heading]</h2>
<p style="font-size:16px;line-height:1.8;color:#444;">[Final section of your article.]</p>

<h2 style="font-size:24px;color:#135879;margin:35px 0 15px;">Conclusion</h2>
<p style="font-size:16px;line-height:1.8;color:#444;">[Wrap up your article with a summary and call to action.]</p>

</div>`,
  },
  {
    id: "blog-howto",
    name: "How-To Guide",
    content_type: "blog",
    description: "Step-by-step guide format with numbered sections, tips, and a summary checklist.",
    icon: "steps",
    html: `<div style="max-width:700px;margin:0 auto;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;color:#333;">

<h1 style="font-size:32px;font-weight:bold;color:#135879;margin-bottom:10px;">How to [Topic]</h1>
<p style="font-size:14px;color:#888;margin-bottom:25px;">[Author] &bull; [Date] &bull; [X] min read</p>

<p style="font-size:17px;line-height:1.7;color:#555;margin-bottom:30px;">[Brief introduction explaining what this guide covers and who it's for.]</p>

<!-- Step 1 -->
<div style="display:flex;gap:20px;margin-bottom:30px;">
  <div style="flex-shrink:0;width:40px;height:40px;background:#135879;color:white;border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:bold;font-size:18px;">1</div>
  <div style="flex:1;">
    <h3 style="margin:0 0 10px;font-size:20px;color:#135879;">[Step 1 Title]</h3>
    <p style="font-size:15px;line-height:1.7;color:#444;margin:0;">[Detailed explanation of step 1.]</p>
  </div>
</div>

<!-- Step 2 -->
<div style="display:flex;gap:20px;margin-bottom:30px;">
  <div style="flex-shrink:0;width:40px;height:40px;background:#135879;color:white;border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:bold;font-size:18px;">2</div>
  <div style="flex:1;">
    <h3 style="margin:0 0 10px;font-size:20px;color:#135879;">[Step 2 Title]</h3>
    <p style="font-size:15px;line-height:1.7;color:#444;margin:0;">[Detailed explanation of step 2.]</p>
  </div>
</div>

<!-- Step 3 -->
<div style="display:flex;gap:20px;margin-bottom:30px;">
  <div style="flex-shrink:0;width:40px;height:40px;background:#135879;color:white;border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:bold;font-size:18px;">3</div>
  <div style="flex:1;">
    <h3 style="margin:0 0 10px;font-size:20px;color:#135879;">[Step 3 Title]</h3>
    <p style="font-size:15px;line-height:1.7;color:#444;margin:0;">[Detailed explanation of step 3.]</p>
  </div>
</div>

<!-- Tips -->
<div style="background:#fef9e7;border:1px solid #f0e4a8;padding:20px 25px;border-radius:10px;margin:30px 0;">
  <h3 style="margin:0 0 10px;color:#8a6d00;font-size:16px;">&#x1f4a1; Pro Tips</h3>
  <ul style="margin:0;padding-left:20px;font-size:14px;line-height:2;color:#555;">
    <li>[Tip 1]</li>
    <li>[Tip 2]</li>
    <li>[Tip 3]</li>
  </ul>
</div>

<!-- Summary -->
<div style="background:#f0f7fa;padding:20px 25px;border-radius:10px;margin-top:30px;">
  <h3 style="margin:0 0 10px;color:#135879;">Quick Summary</h3>
  <ul style="margin:0;padding-left:20px;font-size:15px;line-height:2;color:#444;">
    <li>[Step 1 summary]</li>
    <li>[Step 2 summary]</li>
    <li>[Step 3 summary]</li>
  </ul>
</div>

</div>`,
  },
  {
    id: "video-post",
    name: "Video Post",
    content_type: "video",
    description: "Video embed with description, key takeaways, and related links.",
    icon: "video",
    html: `<div style="max-width:700px;margin:0 auto;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;color:#333;">

<h1 style="font-size:28px;font-weight:bold;color:#135879;margin-bottom:15px;">[Video Title]</h1>

<div style="background:#000;border-radius:12px;padding:60px 20px;text-align:center;margin-bottom:25px;">
  <p style="color:#888;font-size:14px;margin:0;">&#x25b6; Video will be embedded automatically from the Video URL field above</p>
</div>

<p style="font-size:16px;line-height:1.8;color:#444;margin-bottom:25px;">[Description of the video content. What will viewers learn?]</p>

<div style="background:#f0f7fa;padding:20px 25px;border-radius:10px;margin-bottom:25px;">
  <h3 style="margin:0 0 12px;color:#135879;font-size:17px;">Key Takeaways</h3>
  <ul style="margin:0;padding-left:20px;font-size:15px;line-height:2;color:#444;">
    <li>[Takeaway 1]</li>
    <li>[Takeaway 2]</li>
    <li>[Takeaway 3]</li>
  </ul>
</div>

<div style="border-top:1px solid #eee;padding-top:20px;">
  <h3 style="color:#135879;font-size:16px;margin-bottom:10px;">Resources Mentioned</h3>
  <ul style="padding-left:20px;font-size:14px;line-height:2;color:#555;">
    <li><a href="#" style="color:#135879;">[Resource 1]</a></li>
    <li><a href="#" style="color:#135879;">[Resource 2]</a></li>
  </ul>
</div>

</div>`,
  },
  {
    id: "guide-resource",
    name: "Resource Guide",
    content_type: "guide",
    description: "Document-style guide with chapters, sections, and download CTA.",
    icon: "book",
    html: `<div style="max-width:700px;margin:0 auto;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;color:#333;">

<!-- Title Block -->
<div style="background:linear-gradient(135deg,#135879,#0e4562);color:white;padding:35px 30px;border-radius:12px;margin-bottom:30px;">
  <div style="font-size:12px;text-transform:uppercase;letter-spacing:2px;color:#d4af37;margin-bottom:8px;">Resource Guide</div>
  <h1 style="margin:0;font-size:28px;color:white;">[Guide Title]</h1>
  <p style="margin:10px 0 0;font-size:15px;color:rgba(255,255,255,0.8);">[Subtitle or brief description]</p>
</div>

<!-- Table of Contents -->
<div style="background:#f8f6f0;padding:20px 25px;border-radius:10px;margin-bottom:30px;">
  <h3 style="margin:0 0 10px;font-size:14px;text-transform:uppercase;letter-spacing:1px;color:#135879;">Contents</h3>
  <ol style="margin:0;padding-left:20px;font-size:14px;line-height:2.2;color:#555;">
    <li>[Chapter 1 Title]</li>
    <li>[Chapter 2 Title]</li>
    <li>[Chapter 3 Title]</li>
    <li>[Conclusion]</li>
  </ol>
</div>

<!-- Chapter 1 -->
<h2 style="font-size:22px;color:#135879;margin:30px 0 15px;padding-bottom:8px;border-bottom:2px solid #d4af37;">1. [Chapter 1 Title]</h2>
<p style="font-size:15px;line-height:1.8;color:#444;">[Chapter 1 content. Provide detailed information, explanations, and guidance.]</p>

<!-- Chapter 2 -->
<h2 style="font-size:22px;color:#135879;margin:30px 0 15px;padding-bottom:8px;border-bottom:2px solid #d4af37;">2. [Chapter 2 Title]</h2>
<p style="font-size:15px;line-height:1.8;color:#444;">[Chapter 2 content.]</p>

<!-- Chapter 3 -->
<h2 style="font-size:22px;color:#135879;margin:30px 0 15px;padding-bottom:8px;border-bottom:2px solid #d4af37;">3. [Chapter 3 Title]</h2>
<p style="font-size:15px;line-height:1.8;color:#444;">[Chapter 3 content.]</p>

<!-- Conclusion -->
<h2 style="font-size:22px;color:#135879;margin:30px 0 15px;padding-bottom:8px;border-bottom:2px solid #d4af37;">Conclusion</h2>
<p style="font-size:15px;line-height:1.8;color:#444;">[Summary and next steps.]</p>

<!-- CTA -->
<div style="background:linear-gradient(135deg,#135879,#0e4562);padding:30px;border-radius:12px;text-align:center;margin-top:30px;">
  <h3 style="margin:0 0 10px;color:white;font-size:20px;">Need More Help?</h3>
  <p style="margin:0 0 15px;color:rgba(255,255,255,0.8);font-size:14px;">[CTA description]</p>
  <a href="mailto:tr@chicagojamaat.org" style="display:inline-block;background:#d4af37;color:#000;padding:12px 30px;border-radius:8px;font-weight:bold;text-decoration:none;font-size:14px;">Contact Us</a>
</div>

</div>`,
  },
  {
    id: "announcement-notice",
    name: "Community Notice",
    content_type: "announcement",
    description: "Simple announcement format with header, message, action items, and contact info.",
    icon: "megaphone",
    html: `<div style="max-width:700px;margin:0 auto;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;color:#333;">

<div style="background:#d4af37;padding:12px 25px;border-radius:10px 10px 0 0;">
  <p style="margin:0;font-size:12px;text-transform:uppercase;letter-spacing:2px;font-weight:bold;color:#000;">&#x1f4e2; Community Announcement</p>
</div>

<div style="border:1px solid #e0ddd5;border-top:none;border-radius:0 0 10px 10px;padding:30px;">
  <h1 style="font-size:26px;color:#135879;margin:0 0 15px;">[Announcement Title]</h1>

  <p style="font-size:14px;color:#888;margin-bottom:20px;">[Date] | [Category/Department]</p>

  <p style="font-size:16px;line-height:1.8;color:#444;margin-bottom:20px;">[Main announcement message. Keep it clear, concise, and actionable.]</p>

  <div style="background:#f8f6f0;padding:20px;border-radius:8px;margin:20px 0;">
    <h3 style="margin:0 0 10px;font-size:15px;color:#135879;">Key Details</h3>
    <ul style="margin:0;padding-left:20px;font-size:14px;line-height:2;color:#555;">
      <li><strong>What</strong>: [Detail]</li>
      <li><strong>When</strong>: [Date/Time]</li>
      <li><strong>Where</strong>: [Location/Link]</li>
      <li><strong>Who</strong>: [Target audience]</li>
    </ul>
  </div>

  <p style="font-size:15px;line-height:1.8;color:#444;">[Additional details or instructions.]</p>

  <div style="border-top:1px solid #eee;padding-top:20px;margin-top:25px;">
    <p style="font-size:14px;color:#666;margin:0;">For questions, contact: <a href="mailto:tr@chicagojamaat.org" style="color:#135879;font-weight:600;">tr@chicagojamaat.org</a></p>
  </div>
</div>

</div>`,
  },
  {
    id: "announcement-eoi",
    name: "Initiative / Expression of Interest",
    content_type: "announcement",
    description: "Announcement with a call-to-action for community members to express interest. Attach a custom form or Google Form.",
    icon: "megaphone",
    html: `<div style="max-width:700px;margin:0 auto;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;color:#333;">

<!-- Header -->
<div style="background:linear-gradient(135deg,#135879,#0e4562);color:white;padding:40px 30px;border-radius:12px 12px 0 0;text-align:center;">
  <div style="font-size:11px;text-transform:uppercase;letter-spacing:3px;color:#d4af37;margin-bottom:12px;">New Initiative</div>
  <h1 style="margin:0;font-size:26px;font-weight:bold;color:white;line-height:1.3;">[Initiative Title]</h1>
  <p style="margin:12px 0 0;font-size:15px;color:rgba(255,255,255,0.8);">In collaboration with the Chicago Jamaat</p>
</div>
<div style="height:4px;background:#d4af37;margin-bottom:30px;"></div>

<!-- Salaam -->
<div style="padding:0 10px 20px;">
  <p style="font-size:16px;line-height:1.8;color:#444;">Afzalus Salaam,</p>
  <p style="font-size:16px;line-height:1.8;color:#444;">[Opening paragraph — introduce the initiative and the collaborating organizations. Explain what this initiative is about.]</p>

  <!-- What's included -->
  <p style="font-size:16px;line-height:1.8;color:#444;">We are opening a structured process for the following:</p>
  <ul style="font-size:15px;line-height:2;color:#444;padding-left:25px;">
    <li>[Item / Category 1]</li>
    <li>[Item / Category 2]</li>
    <li>[Item / Category 3]</li>
  </ul>
</div>

<!-- Our Vision -->
<div style="background:#f8f6f0;border-left:4px solid #d4af37;padding:25px 30px;margin:10px 0 25px;border-radius:0 10px 10px 0;">
  <h2 style="margin:0 0 12px;font-size:20px;color:#135879;">Our Vision</h2>
  <p style="font-size:15px;line-height:1.8;color:#444;margin:0 0 12px;">[Describe the broader vision and goals of this initiative. What impact do you hope to achieve?]</p>
  <p style="font-size:15px;line-height:1.8;color:#444;margin:0;">By participating, you will have the opportunity to:</p>
  <ul style="font-size:14px;line-height:2.2;color:#555;padding-left:20px;margin-top:8px;">
    <li>[Benefit 1 — e.g., learn professional skills]</li>
    <li>[Benefit 2 — e.g., generate sustainable income]</li>
    <li>[Benefit 3 — e.g., contribute to community khidmat]</li>
  </ul>
</div>

<!-- How to Apply -->
<div style="padding:0 10px 25px;">
  <h2 style="font-size:20px;color:#135879;margin-bottom:12px;">How to Express Your Interest</h2>
  <p style="font-size:15px;line-height:1.8;color:#444;">If you are interested in participating, please fill out the Expression of Interest form below. This will help us understand your capabilities and guide you through the next steps.</p>
</div>

<!-- CTA Button (replaced by actual form below) -->
<div style="text-align:center;padding:10px 10px 30px;">
  <div style="display:inline-block;background:#d4af37;color:#000;padding:14px 35px;border-radius:8px;font-weight:bold;font-size:15px;">Fill Out the Form Below</div>
</div>

<!-- Footer -->
<div style="border-top:1px solid #e0ddd5;padding:25px 10px 10px;text-align:center;">
  <p style="font-size:14px;color:#888;margin:0 0 5px;">Shukran,</p>
  <p style="font-size:14px;font-weight:600;color:#135879;margin:0 0 10px;">The Chicago Tijarat Rabeehah Team<br>In collaboration with Chicago Jamaat</p>
  <p style="font-size:13px;color:#aaa;margin:0;">For questions, contact: <a href="mailto:tr@chicagojamaat.org" style="color:#135879;text-decoration:none;">tr@chicagojamaat.org</a></p>
</div>

</div>`,
  },
  {
    id: "blank",
    name: "Start from Scratch",
    content_type: null, // User picks content_type separately
    description: "Begin with a blank editor. Choose your own content type and format.",
    icon: "blank",
    html: "",
  },
];

export default TEMPLATES;
